export default __webpack_public_path__ + "static/Screenshot4-93b3282f0202ce6d3119f8c968b43b3c.jpg";